import { Controller } from "@hotwired/stimulus"

// References tab controller — add form toggle + generate image via fetch
export default class extends Controller {
  static targets = ["addForm", "lightbox", "lightboxImage"]

  showAddForm() {
    if (this.hasAddFormTarget) {
      this.addFormTarget.classList.remove("hidden")
      const nameInput = this.addFormTarget.querySelector("input[name='name']")
      if (nameInput) nameInput.focus()
    }
  }

  hideAddForm() {
    if (this.hasAddFormTarget) {
      this.addFormTarget.classList.add("hidden")
    }
  }

  async generateImage(event) {
    const button = event.currentTarget
    const url = button.dataset.url
    const setId = button.dataset.setId
    if (!url) return

    this.setButtonLoading(button, true)

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const body = new FormData()
      body.append("set_id", setId)

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body
      })

      const data = await response.json().catch(() => ({}))

      if (!response.ok) {
        throw new Error(data.error || `Request failed (${response.status})`)
      }

      // Success — reload to show the new image
      this.turboReload()
    } catch (error) {
      this.setButtonLoading(button, false)
      console.error("[references] Generate failed:", error.message)
    }
  }

  setButtonLoading(button, loading) {
    const icon = button.querySelector(".generate-icon")
    const spinner = button.querySelector(".generate-spinner")
    const label = button.querySelector(".generate-label")

    if (loading) {
      button.disabled = true
      button.classList.add("opacity-50", "cursor-not-allowed")
      if (icon) icon.classList.add("hidden")
      if (spinner) spinner.classList.remove("hidden")
      if (label) label.textContent = "Generating..."
    } else {
      button.disabled = false
      button.classList.remove("opacity-50", "cursor-not-allowed")
      if (icon) icon.classList.remove("hidden")
      if (spinner) spinner.classList.add("hidden")
      if (label) label.textContent = "Generate"
    }
  }

  openLightbox(event) {
    const url = event.currentTarget.dataset.imageUrl
    const name = event.currentTarget.dataset.imageName || ""
    if (!url || !this.hasLightboxTarget) return

    this.lightboxImageTarget.src = url
    this.lightboxImageTarget.alt = name
    this.lightboxTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  closeLightbox() {
    if (!this.hasLightboxTarget) return

    this.lightboxTarget.classList.add("hidden")
    this.lightboxImageTarget.src = ""
    document.body.classList.remove("overflow-hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  turboReload() {
    if (typeof Turbo !== "undefined" && Turbo.visit) {
      Turbo.visit(window.location.href, { action: "replace" })
    } else {
      window.location.reload()
    }
  }
}
